module.exports = __webpack_public_path__ + "static/media/bg-virtual.cd520d83.mp4";